export const DateAscending = () => {
  return (<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.25 3.5C3.355 3.5 1 5.8475 1 8.75C1 11.6525 3.3475 14 6.25 14C9.145 14 11.5 11.6525 11.5 8.75C11.5 5.8475 9.1525 3.5 6.25 3.5ZM6.25 5.1125C8.2525 5.1125 9.8875 6.74 9.8875 8.75C9.8875 10.76 8.26 12.3875 6.25 12.3875C4.24 12.3875 2.6125 10.76 2.6125 8.75C2.6125 6.74 4.24 5.1125 6.25 5.1125ZM5.5 6.5V9.2675L7.8925 10.6475L8.455 9.6725L6.625 8.615V6.5" fill="black" />
    <path d="M13.25 5L11 5L14 2L17 5L14.75 5L14.75 15.5L13.25 15.5L13.25 5Z" fill="black" />
  </svg>
  )
}